import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'white' | 'coral-light';
}
export function Section({
  children,
  className = '',
  id,
  background = 'cream'
}: SectionProps) {
  const bgColors = {
    cream: 'bg-[#F0FDFA]',
    white: 'bg-white',
    'coral-light': 'bg-[#CCFBF1]'
  };
  return <section id={id} className={`py-16 md:py-24 ${bgColors[background]} ${className}`} data-id="element-247">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-248">{children}</div>
    </section>;
}